<template>
  <v-dialog max-width="550px" persistent v-model="dialog" scrollable>
    <v-card>
      <v-toolbar dark>
        <v-toolbar-title class="headline">{{formTitle}}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-icon @click="cancel()">close</v-icon>
      </v-toolbar>
      <v-card-text style="height: auto;">
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-layout row wrap justify-space-around>
            <v-flex xs4 sm2>
              <div class="title-position">Start point:</div>
            </v-flex>
            <v-flex
              xs8
              sm3
            >{{ dialog == false ? null : select_start.transport_sub_district_start_name }}</v-flex>
            <v-flex xs4 sm2>
              <div class="title-position">End point:</div>
            </v-flex>
            <v-flex xs8 sm3>{{dialog == false ? null : edit_form.transport_sub_district_start_name}}</v-flex>
          </v-layout>
          <v-text-field v-model.number="price" label="Transfer price"></v-text-field>
        </v-form>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <span transition="fade">
          <v-icon color="green" v-if="update_loading == 2">check</v-icon>
          <v-icon color="red" v-if="update_loading == 3">close</v-icon>
          <v-progress-circular
            :width="3"
            :size="15"
            indeterminate
            color="grey"
            v-if="update_loading == 1"
          ></v-progress-circular>
          {{ update_loading == 1 ? 'Updating' : update_loading == 2 ? 'Update successfully' : update_loading == 3? 'Cant update' : null}}
        </span>
        <v-btn color="red" flat @click="cancel()">Cancel</v-btn>
        <v-btn color="green" flat @click="update()" :disabled="isEditTransfer">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState, mapGetters } from "vuex";
export default {
  props: ["dialog", "editedIndex", "edit_form"],
  data() {
    return {
      update_loading: 0,
      price: null,
      valid: true,
      province_item: [
        {
          name: "ภูเก็ต",
          value: 1
        },
        {
          name: "ตรัง",
          value: 2
        }
      ],
      district_item: [
        {
          name: "กะทู้",
          value: 1
        },
        {
          name: "ราไวย์",
          value: 2
        }
      ],
      sub_district_item: [
        {
          name: "กะทู้",
          value: 1
        },
        {
          name: "ราไวย์",
          value: 2
        }
      ]
    };
  },
  watch: {
    dialog() {
      if (this.dialog == true) {
        this.price = this.edit_form.transport_price;
        this.update_loading = 0;
      } else {
      }
    }
  },
  computed: {
    ...mapState({
      select_start: state => state.fetchFoodRateBack.select_start
    }),
    ...mapGetters({
      isEditTransfer: "isEditTransfer"
    }),
    formTitle() {
      return this.editedIndex === -1
        ? "New transfer rate"
        : "Edit transfer rate";
    }
  },
  methods: {
    async update() {
      if (this.update_loading != 1) {
        let form = JSON.parse(JSON.stringify(this.select_start));

        form.transport_province_end_id = this.edit_form.transport_province_start_id;
        form.transport_district_end_id = this.edit_form.transport_district_start_id;
        form.transport_sub_district_end_id = this.edit_form.transport_sub_district_start_id;
        form.transport_price = this.price;
        delete form.transport_sub_district_start_name;
        delete form.tzm_id;
        this.update_loading = 1;
        if (this.edit_form.transport_id) {
          form.transport_id = this.edit_form.transport_id;
        }
        this.update_loading = await this.$store.dispatch(
          "fetchFoodRateBack/updateTransferRate",
          form
        );
        if (this.update_loading == 2) {
          this.edit_form.transport_price = this.price;
          this.cancel();
        }
      }
    },
    cancel() {
      if (this.update_loading != 1) {
        this.$emit("setDialog", false);
        this.$emit("setEditIndex", -1);
      }
    }
  }
};
</script>
<style>
.title-position {
  font-size: 16px;
  font-weight: 600;
}
</style>




